module.exports = __webpack_public_path__ + "img/case2.b3773e7f.png";